import { BemloIcon } from './BemloIcon'
import { DuotoneExclamationCircle } from './DuotoneExclamationCircle'
import { EmptyCircle } from './EmptyCircle'
import { InProgress } from './InProgress'
import * as customOutlineIcons from './outline'
import * as customSolidIcons from './solid'

type DesignIntersection = typeof customSolidIcons & typeof customOutlineIcons

export type CustomIconName = keyof DesignIntersection

// Ensure that both solid and outline have the same icons
const _satisfiesSolid: DesignIntersection = customSolidIcons
const _satisfiesOutline: DesignIntersection = customOutlineIcons

export const BemloIcons = {
  BemloIcon,
  EmptyCircle,
  InProgress,
  DuotoneExclamationCircle,
}

export { customOutlineIcons, customSolidIcons }
